<template>
    <div class="text-center mt-5">
        <div class="spinner-border text-primary"  role="status">
            <span class="sr-only">Cargando ...</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomSpinner',
};
</script>
